















































































































import { Component, Vue } from "@/shared/vuepack";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useCardCustomizationBulkImportStore } from "@/admin/store/cardCustomizationBulkImport";
import { useNotifierStore } from "@/shared/store/notifier";
import { CardCustomizationBulkImportFileStatus } from "@/admin/types";
import { UserPermission } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import FileUpload from "vue-upload-component";
import Pill from "@/shared/components/ui/Pill.vue";
import moment from "moment";

@Component({
  components: {
    GenericLoadingSpinner,
    FileUpload,
    Pill
  }
})
export default class CardCustomizationBulkImport extends Vue {
  readonly fileTemplate = "/debit_card_settings_bulk_import_template.csv";

  cardCustomizationBulkImportStore = useCardCustomizationBulkImportStore();
  notifier = useNotifierStore();
  rolePermissionsStore = useRolePermissionsStore();

  selectedFile = null;
  isUploading = false;
  selectedFileId: number = null;

  get isLoading () {
    return this.cardCustomizationBulkImportStore.isLoading;
  }

  get isLoaded () {
    return this.cardCustomizationBulkImportStore.isLoaded;
  }

  get isFailed () {
    return this.cardCustomizationBulkImportStore.isFailed;
  }

  get hasData () {
    return this.cardCustomizationBulkImportStore.files.length > 0;
  }

  get hasEditPermission () {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalDebitCardSettingBulkImport);
  }

  get fileName () {
    return this.selectedFile ? this.selectedFile.name : "";
  }

  get fileSelectorText () {
    return this.fileName ? this.fileName : "No file selected. Click here to select.";
  }

  get isUploadDisabled () {
    return !this.selectedFile || this.isUploading || this.hasPendingFile;
  }

  get hasPendingFile () {
    return this.cardCustomizationBulkImportStore.files.some(file =>
      file.status === CardCustomizationBulkImportFileStatus.Pending ||
      file.status === CardCustomizationBulkImportFileStatus.Unknown);
  }

  mounted () {
    this.refresh();
  }

  inputFilter (newFile: any, oldFile: any, prevent: any) {
    if (!newFile) {
      return;
    }

    if (!this.isCsv(newFile.name)) {
      this.notifier.setDanger("File type not allowed. Only CSV files are allowed.");
      return prevent();
    }
  }

  isCsv (fileName: string) {
    return /\.csv$/i.test(fileName);
  }

  onFileSelected (file: any) {
    this.selectedFile = file;
  }

  uploadFile () {
    if (!this.selectedFile) {
      return;
    }

    this.isUploading = true;

    this.cardCustomizationBulkImportStore
      .uploadBulkImportFile({
        file: this.selectedFile.file
      })
      .then(() => {
        this.refresh();
      })
      .catch(() => {/* noop */})
      .finally(() => {
        this.isUploading = false;
      });
  }

  downloadResultsFile (fileId: number) {
    this.cardCustomizationBulkImportStore.downloadResultsFile(fileId);
  }

  refresh () {
    this.selectedFile = null;
    this.cardCustomizationBulkImportStore.loadBulkImportFiles();
  }

  getPillType (status: CardCustomizationBulkImportFileStatus) {
    switch (status) {
      case CardCustomizationBulkImportFileStatus.Unknown:
        return "warning-pill";
      case CardCustomizationBulkImportFileStatus.Success:
        return "green-bg";
      case CardCustomizationBulkImportFileStatus.Failed:
        return "red-bg";
      default:
        return "neutral-pill";
    }
  }

  formatDateString (fromString: any) {
    return moment.utc(fromString).local().format("L LT");
  }

  onMouseEnter (fileId: number) {
    this.onHover(fileId, true);
  }

  onMouseLeave (fileId: number) {
    this.onHover(fileId, false);
  }

  onHover (fileId: number, active: boolean) {
    if (active) {
      this.selectedFileId = fileId;
    } else if (this.selectedFileId === fileId) {
      this.selectedFileId = null;
    }
  }
}
